(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    // JOD EDIT: move each card's swatches to sit directly under its photo (order: photo, swatches, title, price, label).
  // Also marks rows whose colors don't all fit (adds the soft fade on the right only when needed).
  if (!window.__jodPlaceSwatches) {
    window.__jodPlaceSwatches = true;
    var jodCheckFit = function () {
      document.querySelectorAll('.jod-card-swatches').forEach(function (s) {
        s.classList.remove('is-overflowing');
        s.classList.toggle('is-overflowing', s.scrollWidth > s.clientWidth + 2);
      });
    };
    var jodPlace = function () {
      var moved = false;
      document.querySelectorAll('.jod-card-swatches:not(.is-placed)').forEach(function (s) {
        var card = s.closest('.product-card') || s.closest('[class*="product-card"]');
        var g = card && card.querySelector('.card-gallery');
        if (g && !g.contains(s)) g.insertAdjacentElement('afterend', s);
        s.classList.add('is-placed');
        moved = true;
      });
      if (moved) requestAnimationFrame(jodCheckFit);
    };
    jodPlace();
    document.addEventListener('DOMContentLoaded', jodPlace);
    window.addEventListener('load', jodCheckFit);
    window.addEventListener('resize', jodCheckFit);
    new MutationObserver(function () { jodPlace(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  // JOD EDIT: tapping a card swatch swaps that card's photo to the color and points the card at that color.
  if (!window.__jodCardSwatches) {
    window.__jodCardSwatches = true;
    document.addEventListener('click', function (e) {
      var s = e.target instanceof Element && e.target.closest('.jod-card-swatch');
      if (!s) return;
      e.preventDefault();
      e.stopPropagation();
      var card = s.closest('.product-card') || s.closest('[class*="product-card"]');
      if (!card) return;
      if (s.dataset.img) {
        var img = card.querySelector('.card-gallery img');
        if (img) {
          img.removeAttribute('loading');
          if (s.dataset.srcset) img.srcset = s.dataset.srcset;
          img.src = s.dataset.img;
        }
      }
      if (s.dataset.url) {
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = s.dataset.url; });
      }
      card.querySelectorAll('.jod-card-swatch').forEach(function (x) { x.classList.toggle('is-active', x === s); });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jod-fabric-video"] && !Shopify.designMode) return;
  try {
    if (!window.__jodFabricVideo) {
    window.__jodFabricVideo = true;
    var jodDesk = window.matchMedia('(min-width: 750px)');
    var jodFvPlace = function () {
      document.querySelectorAll('[data-jod-fv]').forEach(function (box) {
        var sec = box.closest('.shopify-section') || document;
        var media = sec.querySelector('.product-information__media');
        if (jodDesk.matches && media) {
          if (box.parentNode !== media) media.appendChild(box);
          box.classList.add('jod-fv--wide');
        } else {
          box.classList.remove('jod-fv--wide');
          var row = sec.querySelector('.jod-fv-row');
          if (!row) {
            var heads = sec.querySelectorAll('h1, h2, h3, h4');
            for (var j = 0; j < heads.length; j++) {
              if (/^\s*About This/i.test(heads[j].textContent)) {
                row = document.createElement('div');
                row.className = 'jod-fv-row';
                heads[j].parentNode.insertBefore(row, heads[j]);
                row.appendChild(heads[j]);
                break;
              }
            }
          }
          if (row && box.parentNode !== row) row.appendChild(box);
        }
        box.classList.add('is-placed');
      });
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', jodFvPlace); } else { jodFvPlace(); }
    if (jodDesk.addEventListener) { jodDesk.addEventListener('change', jodFvPlace); }
    document.addEventListener('click', function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      var open = t.closest('[data-jod-fv-open]');
      if (open) {
        e.preventDefault();
        var box = open.closest('[data-jod-fv]');
        var dlg = box && box.querySelector('[data-jod-fv-dialog]');
        var holder = box && box.querySelector('[data-jod-fv-holder]');
        var tpl = box && box.querySelector('[data-jod-fv-tpl]');
        if (!dlg) return;
        if (holder && tpl && !holder.firstElementChild) holder.appendChild(tpl.content.cloneNode(true));
        dlg.showModal();
        var v = dlg.querySelector('video');
        if (v) { try { v.play(); } catch (err) {} }
        return;
      }
      var close = t.closest('[data-jod-fv-close]') || (t.matches('[data-jod-fv-dialog]') ? t : null);
      if (close) {
        var d = close.closest('[data-jod-fv-dialog]') || close;
        var vid = d.querySelector('video');
        if (vid) vid.pause();
        d.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
